import {
  API_CALL,
  REDEEM_GIFT_CARD,
  CLEAR_REDEEMED_GIFT_CARDS,
  REMOVE_REDEEMED_GIFT_CARD,
} from './actionConstants'
import { FETCH_GIFT_CARD } from './apiActionConstants'
import { getGiftCard } from 'api/promo'
import type { RedeemedCard } from 'components/Common/RedeemGiftCard/common'
import type { AppAction } from './types/ActionTypes'

export function fetchGiftCard(code: string): AppAction {
  return {
    type: API_CALL,
    api: FETCH_GIFT_CARD,
    request: () => getGiftCard(code),
  }
}

export function redeemGiftCard(card: RedeemedCard): AppAction {
  return {
    type: REDEEM_GIFT_CARD,
    card,
  }
}

export function clearRedeemedGiftCards(): AppAction {
  return {
    type: CLEAR_REDEEMED_GIFT_CARDS,
  }
}

export function removeRedeemedGiftCard(code: string): AppAction {
  return {
    type: REMOVE_REDEEMED_GIFT_CARD,
    code,
  }
}
